import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { IoTExtended, IoTExtendedListResponse, IoTQueryParams } from '@frontend/iot/types';

export class IoTExtendedClient extends APIClient {
    public static readonly endpoint = '/iot-api/ext/v1';

    public static async fetchIoTsExtended(queryParams?: ApiQueryParams<IoTQueryParams>): Promise<IoTExtendedListResponse> {
        return await this.apiPaginated<IoTExtendedListResponse, IoTQueryParams>(`${this.endpoint}/iots`, queryParams);
    }

    public static async fetchIoTExtended(accountId: string, iotId: string): Promise<IoTExtended> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/iots/${iotId}`);
        return await this.handleResponse<IoTExtended>(response);
    }

    public static async fetchIotsCriticalExtended(queryParams?: ApiQueryParams<IoTQueryParams>): Promise<IoTExtendedListResponse> {
        return await this.apiPaginated<IoTExtendedListResponse, IoTQueryParams>(`${this.endpoint}/critical-iots`, queryParams);
    }
}
